export enum UploadContext {
  ISSUES = 'ISSUES',
  REPORT = 'REPORT',
  AUDIT_TEMPLATE = 'AUDIT_TEMPLATE',
  GROUP_AUDIT_TEMPLATE = 'GROUP_AUDIT_TEMPLATE',
}
